import { ComponentPropsWithoutRef, ReactNode } from 'react'
import { clsx } from '@unbridaled/shared/utils/clsx'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { CloseLargeIcon } from '@unbridaled/icons/CloseLargeIcon'
import type { IconProps } from '@unbridaled/icons'
import { RenderComponent } from 'types/react'
import { render } from 'utils/render'

export type ModalTitleProps = ComponentPropsWithoutRef<'div'> & {
  title?: ReactNode
  leadingIcon?: RenderComponent<IconProps>
  trailingIcon?: RenderComponent<IconProps>
  titleClassName?: string
  /**
   * @deprecated use trailingIcon or hideCloseButton to hide
   */
  onClose?: () => void
  hideCloseButton?: boolean
}

export const ModalHeader = ({
  leadingIcon,
  trailingIcon,
  title,
  titleClassName,
  children,
  onClose,
  className,
  hideCloseButton,
  ...props
}: ModalTitleProps): React.ReactNode => (
  <div
    data-slot="header"
    className={clsx(
      'uui-py-4 uui-px-6 uui-flex uui-items-center uui-text-primary',
      'uui-bg-white uui-border-b uui-border-primary uui-rounded-t-md',
      'uui-sticky uui-top-0 uui-z-10',
      className
    )}
    {...props}
  >
    {
      render(leadingIcon, {
        color: 'uui-text-current',
        className: 'uui-mr-2',
        size: 20
      }) as ReactNode
    }
    <ModalTitle className="uui-pr-2">{title || children}</ModalTitle>
    {!trailingIcon && !hideCloseButton && (
      <DialogPrimitive.DialogClose className="uui-ml-auto">
        <CloseLargeIcon color="uui-text-current" />
      </DialogPrimitive.DialogClose>
    )}
    {
      render(trailingIcon, {
        color: 'uui-text-current',
        className: 'uui-ml-auto',
        size: 20
      }) as ReactNode
    }
  </div>
)

export const ModalTitle = ({
  className,
  ...props
}: ComponentPropsWithoutRef<typeof DialogPrimitive.Title>): React.ReactNode => (
  <DialogPrimitive.Title
    data-slot="title"
    className={clsx('uui-text-lg uui-font-medium uui-flex uui-items-center', className)}
    {...props}
  />
)
